/** Tipo MIME interno para distinguir arrasto de OS no Board. */
export const BOARD_ORDER_DRAG_TYPE = 'application/x-painelos-board-order';

/** Origem do drag (ref de módulo — evita setState no dragstart que cancela o gesto). */
let boardOrderDragSource = null;

/**
 * @param {{ fromTechnicianName?: string, fromGroup?: string } | null} source
 */
export function setBoardOrderDragSource(source) {
  boardOrderDragSource =
    source && typeof source === 'object'
      ? {
          fromTechnicianName: String(source.fromTechnicianName || '').trim(),
          fromGroup: String(source.fromGroup || '').trim(),
        }
      : null;
}

export function getBoardOrderDragSource() {
  return boardOrderDragSource;
}

export function clearBoardOrderDragSource() {
  boardOrderDragSource = null;
}

/**
 * Unitário: OS não selecionada → só ela.
 * Multi: OS já selecionada → todo o conjunto selectedOrders.
 */
export function resolveBoardDragOrderIds(selectedOrders, draggedOrderId) {
  const dragged = draggedOrderId != null && draggedOrderId !== '' ? String(draggedOrderId) : '';
  const selected = Array.isArray(selectedOrders) ? selectedOrders : [];
  if (!dragged) return [...selected];
  if (selected.some((id) => String(id) === dragged)) return selected;
  return [draggedOrderId];
}

export function setBoardOrderDragDataTransfer(dataTransfer, orderId, orderIds) {
  if (!dataTransfer) return;
  dataTransfer.effectAllowed = 'move';
  dataTransfer.setData(BOARD_ORDER_DRAG_TYPE, '1');
  if (orderId != null && orderId !== '') {
    dataTransfer.setData('orderId', String(orderId));
  }
  const ids =
    Array.isArray(orderIds) && orderIds.length > 0
      ? orderIds
      : orderId != null && orderId !== ''
        ? [orderId]
        : [];
  if (ids.length > 0) {
    dataTransfer.setData('orderIds', JSON.stringify(ids.map(String)));
  }
}

/** Lê IDs gravados no dragstart (evita race com setState de seleção). */
export function getBoardDragOrderIds(dataTransfer, selectedOrdersFallback = []) {
  try {
    const raw = dataTransfer?.getData('orderIds');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (_e) {
    /* ignore */
  }
  const orderId = dataTransfer?.getData('orderId');
  return resolveBoardDragOrderIds(selectedOrdersFallback, orderId);
}

export function sameBoardOrderId(ordem, orderId) {
  const want = String(orderId ?? '').trim();
  if (!want) return false;
  return String(ordem?.id ?? '').trim() === want || String(ordem?.TB02115_CODIGO ?? '').trim() === want;
}

export function isBoardOrderDragEvent(e) {
  const types = Array.from(e?.dataTransfer?.types || []);
  const isColumnReorder = types.includes('columnindex') || types.includes('dragtype');
  if (isColumnReorder) return false;
  return types.some((t) => t === BOARD_ORDER_DRAG_TYPE.toLowerCase() || t === 'fromtechnician');
}
